import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// ============ INTERFACE ============

export interface ProgressBarStateInterface {
  percentage: number;
}

// ============ INIT STATE ============

const initialState: ProgressBarStateInterface = {
  percentage: 0
};

// ========= SLICE ==========

export const progressBarSlice = createSlice({
  name: 'progressBar',
  initialState,
  reducers: {
    setProgressBarPercentage: (state: ProgressBarStateInterface, action: PayloadAction<number>) => {
      state.percentage = action.payload;
    }
  }
})

export const { setProgressBarPercentage } = progressBarSlice.actions;

export default progressBarSlice.reducer;